import { defineComponent as J, ref as I, computed as Y, onMounted as Q, onUnmounted as ee, openBlock as te, createElementBlock as ie, normalizeClass as ne, createElementVNode as $, renderSlot as ae } from "vue";
import se from "swiper";
import { _ as le } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './css/Slider.css';function V(a) {
  return a !== null && typeof a == "object" && "constructor" in a && a.constructor === Object;
}
function F(a, e) {
  a === void 0 && (a = {}), e === void 0 && (e = {}), Object.keys(e).forEach((u) => {
    typeof a[u] > "u" ? a[u] = e[u] : V(e[u]) && V(a[u]) && Object.keys(e[u]).length > 0 && F(a[u], e[u]);
  });
}
const W = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function U() {
  const a = typeof document < "u" ? document : {};
  return F(a, W), a;
}
const re = {
  document: W,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(a) {
    return typeof setTimeout > "u" ? (a(), null) : setTimeout(a, 0);
  },
  cancelAnimationFrame(a) {
    typeof setTimeout > "u" || clearTimeout(a);
  }
};
function z() {
  const a = typeof window < "u" ? window : {};
  return F(a, re), a;
}
function oe(a) {
  return a === void 0 && (a = ""), a.trim().split(" ").filter((e) => !!e.trim());
}
function j(a, e) {
  return e === void 0 && (e = 0), setTimeout(a, e);
}
function O() {
  return Date.now();
}
function de(a, e) {
  e === void 0 && (e = "");
  const u = [...a.children];
  return a instanceof HTMLSlotElement && u.push(...a.assignedElements()), e ? u.filter((d) => d.matches(e)) : u;
}
function ce(a, e) {
  e === void 0 && (e = []);
  const u = document.createElement(a);
  return u.classList.add(...Array.isArray(e) ? e : oe(e)), u;
}
function ue(a) {
  const e = z(), u = U(), d = a.getBoundingClientRect(), y = u.body, m = a.clientTop || y.clientTop || 0, L = a.clientLeft || y.clientLeft || 0, C = a === e ? e.scrollY : a.scrollTop, x = a === e ? e.scrollX : a.scrollLeft;
  return {
    top: d.top + C - m,
    left: d.left + x - L
  };
}
function R(a) {
  let e = a, u;
  if (e) {
    for (u = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (u += 1);
    return u;
  }
}
function q(a, e) {
  const u = [];
  let d = a.parentElement;
  for (; d; )
    e ? d.matches(e) && u.push(d) : u.push(d), d = d.parentElement;
  return u;
}
function fe(a, e, u) {
  const d = z();
  return a[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(d.getComputedStyle(a, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(d.getComputedStyle(a, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function A(a) {
  return (Array.isArray(a) ? a : [a]).filter((e) => !!e);
}
function pe(a) {
  let {
    swiper: e,
    extendParams: u,
    on: d,
    emit: y
  } = a;
  const m = U(), L = z();
  e.keyboard = {
    enabled: !1
  }, u({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function C(P) {
    if (!e.enabled) return;
    const {
      rtlTranslate: D
    } = e;
    let r = P;
    r.originalEvent && (r = r.originalEvent);
    const S = r.keyCode || r.charCode, l = e.params.keyboard.pageUpDown, s = l && S === 33, g = l && S === 34, f = S === 37, i = S === 39, t = S === 38, n = S === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && i || e.isVertical() && n || g) || !e.allowSlidePrev && (e.isHorizontal() && f || e.isVertical() && t || s))
      return !1;
    if (!(r.shiftKey || r.altKey || r.ctrlKey || r.metaKey) && !(m.activeElement && m.activeElement.nodeName && (m.activeElement.nodeName.toLowerCase() === "input" || m.activeElement.nodeName.toLowerCase() === "textarea"))) {
      if (e.params.keyboard.onlyInViewport && (s || g || f || i || t || n)) {
        let p = !1;
        if (q(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && q(e.el, `.${e.params.slideActiveClass}`).length === 0)
          return;
        const w = e.el, k = w.clientWidth, M = w.clientHeight, o = L.innerWidth, E = L.innerHeight, h = ue(w);
        D && (h.left -= w.scrollLeft);
        const B = [[h.left, h.top], [h.left + k, h.top], [h.left, h.top + M], [h.left + k, h.top + M]];
        for (let c = 0; c < B.length; c += 1) {
          const b = B[c];
          if (b[0] >= 0 && b[0] <= o && b[1] >= 0 && b[1] <= E) {
            if (b[0] === 0 && b[1] === 0) continue;
            p = !0;
          }
        }
        if (!p) return;
      }
      e.isHorizontal() ? ((s || g || f || i) && (r.preventDefault ? r.preventDefault() : r.returnValue = !1), ((g || i) && !D || (s || f) && D) && e.slideNext(), ((s || f) && !D || (g || i) && D) && e.slidePrev()) : ((s || g || t || n) && (r.preventDefault ? r.preventDefault() : r.returnValue = !1), (g || n) && e.slideNext(), (s || t) && e.slidePrev()), y("keyPress", S);
    }
  }
  function x() {
    e.keyboard.enabled || (m.addEventListener("keydown", C), e.keyboard.enabled = !0);
  }
  function v() {
    e.keyboard.enabled && (m.removeEventListener("keydown", C), e.keyboard.enabled = !1);
  }
  d("init", () => {
    e.params.keyboard.enabled && x();
  }), d("destroy", () => {
    e.keyboard.enabled && v();
  }), Object.assign(e.keyboard, {
    enable: x,
    disable: v
  });
}
function me(a) {
  let {
    swiper: e,
    extendParams: u,
    on: d,
    emit: y
  } = a;
  const m = z();
  u({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: "container",
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: "swiper-no-mousewheel"
    }
  }), e.mousewheel = {
    enabled: !1
  };
  let L, C = O(), x;
  const v = [];
  function P(t) {
    let k = 0, M = 0, o = 0, E = 0;
    return "detail" in t && (M = t.detail), "wheelDelta" in t && (M = -t.wheelDelta / 120), "wheelDeltaY" in t && (M = -t.wheelDeltaY / 120), "wheelDeltaX" in t && (k = -t.wheelDeltaX / 120), "axis" in t && t.axis === t.HORIZONTAL_AXIS && (k = M, M = 0), o = k * 10, E = M * 10, "deltaY" in t && (E = t.deltaY), "deltaX" in t && (o = t.deltaX), t.shiftKey && !o && (o = E, E = 0), (o || E) && t.deltaMode && (t.deltaMode === 1 ? (o *= 40, E *= 40) : (o *= 800, E *= 800)), o && !k && (k = o < 1 ? -1 : 1), E && !M && (M = E < 1 ? -1 : 1), {
      spinX: k,
      spinY: M,
      pixelX: o,
      pixelY: E
    };
  }
  function D() {
    e.enabled && (e.mouseEntered = !0);
  }
  function r() {
    e.enabled && (e.mouseEntered = !1);
  }
  function S(t) {
    return e.params.mousewheel.thresholdDelta && t.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && O() - C < e.params.mousewheel.thresholdTime ? !1 : t.delta >= 6 && O() - C < 60 ? !0 : (t.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), y("scroll", t.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), y("scroll", t.raw)), C = new m.Date().getTime(), !1);
  }
  function l(t) {
    const n = e.params.mousewheel;
    if (t.direction < 0) {
      if (e.isEnd && !e.params.loop && n.releaseOnEdges)
        return !0;
    } else if (e.isBeginning && !e.params.loop && n.releaseOnEdges)
      return !0;
    return !1;
  }
  function s(t) {
    let n = t, p = !0;
    if (!e.enabled || t.target.closest(`.${e.params.mousewheel.noMousewheelClass}`)) return;
    const w = e.params.mousewheel;
    e.params.cssMode && n.preventDefault();
    let k = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (k = document.querySelector(e.params.mousewheel.eventsTarget));
    const M = k && k.contains(n.target);
    if (!e.mouseEntered && !M && !w.releaseOnEdges) return !0;
    n.originalEvent && (n = n.originalEvent);
    let o = 0;
    const E = e.rtlTranslate ? -1 : 1, h = P(n);
    if (w.forceToAxis)
      if (e.isHorizontal())
        if (Math.abs(h.pixelX) > Math.abs(h.pixelY)) o = -h.pixelX * E;
        else return !0;
      else if (Math.abs(h.pixelY) > Math.abs(h.pixelX)) o = -h.pixelY;
      else return !0;
    else
      o = Math.abs(h.pixelX) > Math.abs(h.pixelY) ? -h.pixelX * E : -h.pixelY;
    if (o === 0) return !0;
    w.invert && (o = -o);
    let B = e.getTranslate() + o * w.sensitivity;
    if (B >= e.minTranslate() && (B = e.minTranslate()), B <= e.maxTranslate() && (B = e.maxTranslate()), p = e.params.loop ? !0 : !(B === e.minTranslate() || B === e.maxTranslate()), p && e.params.nested && n.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
      const c = {
        time: O(),
        delta: Math.abs(o),
        direction: Math.sign(o),
        raw: t
      };
      v.length >= 2 && v.shift();
      const b = v.length ? v[v.length - 1] : void 0;
      if (v.push(c), b ? (c.direction !== b.direction || c.delta > b.delta || c.time > b.time + 150) && S(c) : S(c), l(c))
        return !0;
    } else {
      const c = {
        time: O(),
        delta: Math.abs(o),
        direction: Math.sign(o)
      }, b = x && c.time < x.time + 500 && c.delta <= x.delta && c.direction === x.direction;
      if (!b) {
        x = void 0;
        let T = e.getTranslate() + o * w.sensitivity;
        const H = e.isBeginning, Z = e.isEnd;
        if (T >= e.minTranslate() && (T = e.minTranslate()), T <= e.maxTranslate() && (T = e.maxTranslate()), e.setTransition(0), e.setTranslate(T), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!H && e.isBeginning || !Z && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({
          direction: c.direction < 0 ? "next" : "prev",
          byMousewheel: !0
        }), e.params.freeMode.sticky) {
          clearTimeout(L), L = void 0, v.length >= 15 && v.shift();
          const X = v.length ? v[v.length - 1] : void 0, G = v[0];
          if (v.push(c), X && (c.delta > X.delta || c.direction !== X.direction))
            v.splice(0);
          else if (v.length >= 15 && c.time - G.time < 500 && G.delta - c.delta >= 1 && c.delta <= 6) {
            const _ = o > 0 ? 0.8 : 0.2;
            x = c, v.splice(0), L = j(() => {
              e.destroyed || !e.params || e.slideToClosest(e.params.speed, !0, void 0, _);
            }, 0);
          }
          L || (L = j(() => {
            if (e.destroyed || !e.params) return;
            const _ = 0.5;
            x = c, v.splice(0), e.slideToClosest(e.params.speed, !0, void 0, _);
          }, 500));
        }
        if (b || y("scroll", n), e.params.autoplay && e.params.autoplayDisableOnInteraction && e.autoplay.stop(), w.releaseOnEdges && (T === e.minTranslate() || T === e.maxTranslate()))
          return !0;
      }
    }
    return n.preventDefault ? n.preventDefault() : n.returnValue = !1, !1;
  }
  function g(t) {
    let n = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (n = document.querySelector(e.params.mousewheel.eventsTarget)), n[t]("mouseenter", D), n[t]("mouseleave", r), n[t]("wheel", s);
  }
  function f() {
    return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", s), !0) : e.mousewheel.enabled ? !1 : (g("addEventListener"), e.mousewheel.enabled = !0, !0);
  }
  function i() {
    return e.params.cssMode ? (e.wrapperEl.addEventListener(event, s), !0) : e.mousewheel.enabled ? (g("removeEventListener"), e.mousewheel.enabled = !1, !0) : !1;
  }
  d("init", () => {
    !e.params.mousewheel.enabled && e.params.cssMode && i(), e.params.mousewheel.enabled && f();
  }), d("destroy", () => {
    e.params.cssMode && f(), e.mousewheel.enabled && i();
  }), Object.assign(e.mousewheel, {
    enable: f,
    disable: i
  });
}
function K(a, e, u, d) {
  return a.params.createElements && Object.keys(d).forEach((y) => {
    if (!u[y] && u.auto === !0) {
      let m = de(a.el, `.${d[y]}`)[0];
      m || (m = ce("div", d[y]), m.className = d[y], a.el.append(m)), u[y] = m, e[y] = m;
    }
  }), u;
}
function ge(a) {
  let {
    swiper: e,
    extendParams: u,
    on: d,
    emit: y
  } = a;
  u({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  function m(l) {
    let s;
    return l && typeof l == "string" && e.isElement && (s = e.el.querySelector(l) || e.hostEl.querySelector(l), s) ? s : (l && (typeof l == "string" && (s = [...document.querySelectorAll(l)]), e.params.uniqueNavElements && typeof l == "string" && s && s.length > 1 && e.el.querySelectorAll(l).length === 1 ? s = e.el.querySelector(l) : s && s.length === 1 && (s = s[0])), l && !s ? l : s);
  }
  function L(l, s) {
    const g = e.params.navigation;
    l = A(l), l.forEach((f) => {
      f && (f.classList[s ? "add" : "remove"](...g.disabledClass.split(" ")), f.tagName === "BUTTON" && (f.disabled = s), e.params.watchOverflow && e.enabled && f.classList[e.isLocked ? "add" : "remove"](g.lockClass));
    });
  }
  function C() {
    const {
      nextEl: l,
      prevEl: s
    } = e.navigation;
    if (e.params.loop) {
      L(s, !1), L(l, !1);
      return;
    }
    L(s, e.isBeginning && !e.params.rewind), L(l, e.isEnd && !e.params.rewind);
  }
  function x(l) {
    l.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), y("navigationPrev"));
  }
  function v(l) {
    l.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), y("navigationNext"));
  }
  function P() {
    const l = e.params.navigation;
    if (e.params.navigation = K(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(l.nextEl || l.prevEl)) return;
    let s = m(l.nextEl), g = m(l.prevEl);
    Object.assign(e.navigation, {
      nextEl: s,
      prevEl: g
    }), s = A(s), g = A(g);
    const f = (i, t) => {
      i && i.addEventListener("click", t === "next" ? v : x), !e.enabled && i && i.classList.add(...l.lockClass.split(" "));
    };
    s.forEach((i) => f(i, "next")), g.forEach((i) => f(i, "prev"));
  }
  function D() {
    let {
      nextEl: l,
      prevEl: s
    } = e.navigation;
    l = A(l), s = A(s);
    const g = (f, i) => {
      f.removeEventListener("click", i === "next" ? v : x), f.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    l.forEach((f) => g(f, "next")), s.forEach((f) => g(f, "prev"));
  }
  d("init", () => {
    e.params.navigation.enabled === !1 ? S() : (P(), C());
  }), d("toEdge fromEdge lock unlock", () => {
    C();
  }), d("destroy", () => {
    D();
  }), d("enable disable", () => {
    let {
      nextEl: l,
      prevEl: s
    } = e.navigation;
    if (l = A(l), s = A(s), e.enabled) {
      C();
      return;
    }
    [...l, ...s].filter((g) => !!g).forEach((g) => g.classList.add(e.params.navigation.lockClass));
  }), d("click", (l, s) => {
    let {
      nextEl: g,
      prevEl: f
    } = e.navigation;
    g = A(g), f = A(f);
    const i = s.target;
    let t = f.includes(i) || g.includes(i);
    if (e.isElement && !t) {
      const n = s.path || s.composedPath && s.composedPath();
      n && (t = n.find((p) => g.includes(p) || f.includes(p)));
    }
    if (e.params.navigation.hideOnClick && !t) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === i || e.pagination.el.contains(i))) return;
      let n;
      g.length ? n = g[0].classList.contains(e.params.navigation.hiddenClass) : f.length && (n = f[0].classList.contains(e.params.navigation.hiddenClass)), y(n === !0 ? "navigationShow" : "navigationHide"), [...g, ...f].filter((p) => !!p).forEach((p) => p.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const r = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), P(), C();
  }, S = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), D();
  };
  Object.assign(e.navigation, {
    enable: r,
    disable: S,
    update: C,
    init: P,
    destroy: D
  });
}
function N(a) {
  return a === void 0 && (a = ""), `.${a.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function he(a) {
  let {
    swiper: e,
    extendParams: u,
    on: d,
    emit: y
  } = a;
  const m = "swiper-pagination";
  u({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (i) => i,
      formatFractionTotal: (i) => i,
      bulletClass: `${m}-bullet`,
      bulletActiveClass: `${m}-bullet-active`,
      modifierClass: `${m}-`,
      currentClass: `${m}-current`,
      totalClass: `${m}-total`,
      hiddenClass: `${m}-hidden`,
      progressbarFillClass: `${m}-progressbar-fill`,
      progressbarOppositeClass: `${m}-progressbar-opposite`,
      clickableClass: `${m}-clickable`,
      lockClass: `${m}-lock`,
      horizontalClass: `${m}-horizontal`,
      verticalClass: `${m}-vertical`,
      paginationDisabledClass: `${m}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let L, C = 0;
  function x() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function v(i, t) {
    const {
      bulletActiveClass: n
    } = e.params.pagination;
    i && (i = i[`${t === "prev" ? "previous" : "next"}ElementSibling`], i && (i.classList.add(`${n}-${t}`), i = i[`${t === "prev" ? "previous" : "next"}ElementSibling`], i && i.classList.add(`${n}-${t}-${t}`)));
  }
  function P(i, t, n) {
    if (i = i % n, t = t % n, t === i + 1)
      return "next";
    if (t === i - 1)
      return "previous";
  }
  function D(i) {
    const t = i.target.closest(N(e.params.pagination.bulletClass));
    if (!t)
      return;
    i.preventDefault();
    const n = R(t) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === n) return;
      const p = P(e.realIndex, n, e.slides.length);
      p === "next" ? e.slideNext() : p === "previous" ? e.slidePrev() : e.slideToLoop(n);
    } else
      e.slideTo(n);
  }
  function r() {
    const i = e.rtl, t = e.params.pagination;
    if (x()) return;
    let n = e.pagination.el;
    n = A(n);
    let p, w;
    const k = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, M = e.params.loop ? Math.ceil(k / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (w = e.previousRealIndex || 0, p = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (p = e.snapIndex, w = e.previousSnapIndex) : (w = e.previousIndex || 0, p = e.activeIndex || 0), t.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const o = e.pagination.bullets;
      let E, h, B;
      if (t.dynamicBullets && (L = fe(o[0], e.isHorizontal() ? "width" : "height"), n.forEach((c) => {
        c.style[e.isHorizontal() ? "width" : "height"] = `${L * (t.dynamicMainBullets + 4)}px`;
      }), t.dynamicMainBullets > 1 && w !== void 0 && (C += p - (w || 0), C > t.dynamicMainBullets - 1 ? C = t.dynamicMainBullets - 1 : C < 0 && (C = 0)), E = Math.max(p - C, 0), h = E + (Math.min(o.length, t.dynamicMainBullets) - 1), B = (h + E) / 2), o.forEach((c) => {
        const b = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((T) => `${t.bulletActiveClass}${T}`)].map((T) => typeof T == "string" && T.includes(" ") ? T.split(" ") : T).flat();
        c.classList.remove(...b);
      }), n.length > 1)
        o.forEach((c) => {
          const b = R(c);
          b === p ? c.classList.add(...t.bulletActiveClass.split(" ")) : e.isElement && c.setAttribute("part", "bullet"), t.dynamicBullets && (b >= E && b <= h && c.classList.add(...`${t.bulletActiveClass}-main`.split(" ")), b === E && v(c, "prev"), b === h && v(c, "next"));
        });
      else {
        const c = o[p];
        if (c && c.classList.add(...t.bulletActiveClass.split(" ")), e.isElement && o.forEach((b, T) => {
          b.setAttribute("part", T === p ? "bullet-active" : "bullet");
        }), t.dynamicBullets) {
          const b = o[E], T = o[h];
          for (let H = E; H <= h; H += 1)
            o[H] && o[H].classList.add(...`${t.bulletActiveClass}-main`.split(" "));
          v(b, "prev"), v(T, "next");
        }
      }
      if (t.dynamicBullets) {
        const c = Math.min(o.length, t.dynamicMainBullets + 4), b = (L * c - L) / 2 - B * L, T = i ? "right" : "left";
        o.forEach((H) => {
          H.style[e.isHorizontal() ? T : "top"] = `${b}px`;
        });
      }
    }
    n.forEach((o, E) => {
      if (t.type === "fraction" && (o.querySelectorAll(N(t.currentClass)).forEach((h) => {
        h.textContent = t.formatFractionCurrent(p + 1);
      }), o.querySelectorAll(N(t.totalClass)).forEach((h) => {
        h.textContent = t.formatFractionTotal(M);
      })), t.type === "progressbar") {
        let h;
        t.progressbarOpposite ? h = e.isHorizontal() ? "vertical" : "horizontal" : h = e.isHorizontal() ? "horizontal" : "vertical";
        const B = (p + 1) / M;
        let c = 1, b = 1;
        h === "horizontal" ? c = B : b = B, o.querySelectorAll(N(t.progressbarFillClass)).forEach((T) => {
          T.style.transform = `translate3d(0,0,0) scaleX(${c}) scaleY(${b})`, T.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      t.type === "custom" && t.renderCustom ? (o.innerHTML = t.renderCustom(e, p + 1, M), E === 0 && y("paginationRender", o)) : (E === 0 && y("paginationRender", o), y("paginationUpdate", o)), e.params.watchOverflow && e.enabled && o.classList[e.isLocked ? "add" : "remove"](t.lockClass);
    });
  }
  function S() {
    const i = e.params.pagination;
    if (x()) return;
    const t = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let n = e.pagination.el;
    n = A(n);
    let p = "";
    if (i.type === "bullets") {
      let w = e.params.loop ? Math.ceil(t / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && w > t && (w = t);
      for (let k = 0; k < w; k += 1)
        i.renderBullet ? p += i.renderBullet.call(e, k, i.bulletClass) : p += `<${i.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${i.bulletClass}"></${i.bulletElement}>`;
    }
    i.type === "fraction" && (i.renderFraction ? p = i.renderFraction.call(e, i.currentClass, i.totalClass) : p = `<span class="${i.currentClass}"></span> / <span class="${i.totalClass}"></span>`), i.type === "progressbar" && (i.renderProgressbar ? p = i.renderProgressbar.call(e, i.progressbarFillClass) : p = `<span class="${i.progressbarFillClass}"></span>`), e.pagination.bullets = [], n.forEach((w) => {
      i.type !== "custom" && (w.innerHTML = p || ""), i.type === "bullets" && e.pagination.bullets.push(...w.querySelectorAll(N(i.bulletClass)));
    }), i.type !== "custom" && y("paginationRender", n[0]);
  }
  function l() {
    e.params.pagination = K(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const i = e.params.pagination;
    if (!i.el) return;
    let t;
    typeof i.el == "string" && e.isElement && (t = e.el.querySelector(i.el)), !t && typeof i.el == "string" && (t = [...document.querySelectorAll(i.el)]), t || (t = i.el), !(!t || t.length === 0) && (e.params.uniqueNavElements && typeof i.el == "string" && Array.isArray(t) && t.length > 1 && (t = [...e.el.querySelectorAll(i.el)], t.length > 1 && (t = t.filter((n) => q(n, ".swiper")[0] === e.el)[0])), Array.isArray(t) && t.length === 1 && (t = t[0]), Object.assign(e.pagination, {
      el: t
    }), t = A(t), t.forEach((n) => {
      i.type === "bullets" && i.clickable && n.classList.add(...(i.clickableClass || "").split(" ")), n.classList.add(i.modifierClass + i.type), n.classList.add(e.isHorizontal() ? i.horizontalClass : i.verticalClass), i.type === "bullets" && i.dynamicBullets && (n.classList.add(`${i.modifierClass}${i.type}-dynamic`), C = 0, i.dynamicMainBullets < 1 && (i.dynamicMainBullets = 1)), i.type === "progressbar" && i.progressbarOpposite && n.classList.add(i.progressbarOppositeClass), i.clickable && n.addEventListener("click", D), e.enabled || n.classList.add(i.lockClass);
    }));
  }
  function s() {
    const i = e.params.pagination;
    if (x()) return;
    let t = e.pagination.el;
    t && (t = A(t), t.forEach((n) => {
      n.classList.remove(i.hiddenClass), n.classList.remove(i.modifierClass + i.type), n.classList.remove(e.isHorizontal() ? i.horizontalClass : i.verticalClass), i.clickable && (n.classList.remove(...(i.clickableClass || "").split(" ")), n.removeEventListener("click", D));
    })), e.pagination.bullets && e.pagination.bullets.forEach((n) => n.classList.remove(...i.bulletActiveClass.split(" ")));
  }
  d("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const i = e.params.pagination;
    let {
      el: t
    } = e.pagination;
    t = A(t), t.forEach((n) => {
      n.classList.remove(i.horizontalClass, i.verticalClass), n.classList.add(e.isHorizontal() ? i.horizontalClass : i.verticalClass);
    });
  }), d("init", () => {
    e.params.pagination.enabled === !1 ? f() : (l(), S(), r());
  }), d("activeIndexChange", () => {
    typeof e.snapIndex > "u" && r();
  }), d("snapIndexChange", () => {
    r();
  }), d("snapGridLengthChange", () => {
    S(), r();
  }), d("destroy", () => {
    s();
  }), d("enable disable", () => {
    let {
      el: i
    } = e.pagination;
    i && (i = A(i), i.forEach((t) => t.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), d("lock unlock", () => {
    r();
  }), d("click", (i, t) => {
    const n = t.target, p = A(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && p && p.length > 0 && !n.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && n === e.navigation.nextEl || e.navigation.prevEl && n === e.navigation.prevEl)) return;
      const w = p[0].classList.contains(e.params.pagination.hiddenClass);
      y(w === !0 ? "paginationShow" : "paginationHide"), p.forEach((k) => k.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const g = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: i
    } = e.pagination;
    i && (i = A(i), i.forEach((t) => t.classList.remove(e.params.pagination.paginationDisabledClass))), l(), S(), r();
  }, f = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: i
    } = e.pagination;
    i && (i = A(i), i.forEach((t) => t.classList.add(e.params.pagination.paginationDisabledClass))), s();
  };
  Object.assign(e.pagination, {
    enable: g,
    disable: f,
    render: S,
    update: r,
    init: l,
    destroy: s
  });
}
const ve = { class: "slider-wrapper swiper-wrapper" }, be = { class: "slider-navigation" }, ye = /* @__PURE__ */ J({
  __name: "Slider",
  props: {
    /**
     * When true, applies negative left margin on first slide to left-align content
     * @default true
     */
    firstSlideLeft: {
      type: Boolean,
      default: !0
    },
    /**
     * When true, first slide has no background and shows a right border instead
     * @default false
     */
    firstSlideSection: {
      type: Boolean,
      default: !1
    },
    /**
     * Theme variant for styling adjustments.
     * - 'dasei': Circle activator on mobile (2/5 visible, overlaying slide)
     * @default undefined
     */
    theme: {
      type: String,
      default: void 0
    }
  },
  emits: ["slideChange"],
  setup(a, { expose: e, emit: u }) {
    const d = u, y = I(), m = I(), L = I(), C = I(), x = I(0), v = I(0), P = Y(() => x.value === 0), D = Y(() => x.value === v.value - 1);
    e({
      isFirstSlide: P,
      isLastSlide: D,
      slideCount: v,
      currentSlidePos: x
    });
    let r;
    const S = () => {
      r && (x.value = r.activeIndex, v.value = r.slides.length, d("slideChange", {
        isFirstSlide: P.value,
        isLastSlide: D.value,
        slideCount: v.value,
        currentSlidePos: x.value
      }));
    };
    let l = null;
    const s = () => {
      l && clearTimeout(l), l = setTimeout(() => {
        r == null || r.updateAutoHeight(0), r == null || r.update();
      }, 100);
    };
    return Q(() => {
      r = new se(y.value, {
        modules: [pe, me, ge, he],
        slidesPerView: "auto",
        autoHeight: !0,
        speed: 400,
        observer: !0,
        observeParents: !0,
        observeSlideChildren: !0,
        keyboard: {
          enabled: !0
        },
        mousewheel: {
          enabled: !0,
          forceToAxis: !0
        },
        navigation: {
          prevEl: m.value,
          nextEl: L.value
        },
        pagination: {
          el: C.value,
          clickable: !0
        },
        on: {
          init: () => {
            S(), setTimeout(() => r == null ? void 0 : r.updateAutoHeight(0), 50);
          },
          slideChange: S,
          slideChangeTransitionEnd: () => {
            r == null || r.updateAutoHeight(0);
          },
          resize: () => {
            r == null || r.updateAutoHeight(0);
          }
        }
      }), window.addEventListener("resize", s);
    }), ee(() => {
      r == null || r.destroy(), window.removeEventListener("resize", s), l && clearTimeout(l);
    }), (g, f) => (te(), ie("div", {
      class: ne(["slider", [{ "first-slide-left": a.firstSlideLeft && P.value, "first-slide-section": a.firstSlideSection && P.value, "is-first-slide": P.value }, a.theme ? `slider--${a.theme}` : ""]])
    }, [
      $("div", {
        ref_key: "root",
        ref: y,
        class: "slider-inner swiper-container"
      }, [
        $("div", ve, [
          ae(g.$slots, "default", {}, void 0, !0)
        ]),
        $("div", be, [
          $("button", {
            "aria-label": "Vorheriger Slide",
            ref_key: "prevSlide",
            ref: m
          }, [...f[0] || (f[0] = [
            $("svg", {
              fill: "currentColor",
              height: "32",
              viewBox: "0 0 256 256",
              width: "32",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              $("path", { d: "M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z" })
            ], -1)
          ])], 512),
          $("button", {
            "aria-label": "Nächster Slide",
            ref_key: "nextSlide",
            ref: L
          }, [...f[1] || (f[1] = [
            $("svg", {
              fill: "currentColor",
              height: "32",
              viewBox: "0 0 256 256",
              width: "32",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              $("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" })
            ], -1)
          ])], 512)
        ])
      ], 512),
      $("div", {
        ref_key: "pagination",
        ref: C,
        class: "slider-pagination"
      }, null, 512)
    ], 2));
  }
}), xe = /* @__PURE__ */ le(ye, [["__scopeId", "data-v-c3e221e4"]]);
export {
  xe as default
};
